import { MarkdownEditor, ViewMode } from '@efdigital/ll-addon-codemirror';
import type { Quiz } from '@efdigital/ll-addon-data';
import { selectValue } from '@efdigital/ll-addon-ui/modifiers/select-value';
import { SidebarAll } from '@efdigital/ll-admin-v2/lib/markdown-toolbar';
import { on } from '@ember/modifier';
import Component from '@glimmer/component';

import { EditRecord, type EditRecordSignature } from '../edit-record.gts';

enum QuizOutputTemplate {
  Default = 'default',
  Certificate = 'certificate',
}

const OUTPUT_TEMPLATES = Object.entries(QuizOutputTemplate).map(
  ([key, value]) => ({
    key,
    value,
  })
);

export class EditQuizOutput extends Component<EditRecordSignature<Quiz>> {
  setMarkdownOutput = (markdown: string) => {
    this.args.item.markdownOutput = markdown;
  };

  setTemplateOutput = (event: Event) => {
    const target = event.target as HTMLSelectElement;
    this.args.item.templateOutput = target.value;
  };

  <template>
    <EditRecord
      @editLabel="Edit Results Presentation"
      @item={{@item}}
      @context={{@context}}
      ...attributes
    >
      <:form as |uniqueId isDisabled isReadOnly|>
        <fieldset disabled={{isDisabled}} class="mb-0">
          <legend class="gud-eyebrow">Results Presentation</legend>

          <div class="form-group mb-3">
            <label for="{{uniqueId}}-template">Layout</label>
            <p class="form-text text-muted">This controls the layout of the
              results page.</p>
            <select
              class="form-control"
              id="{{uniqueId}}-template"
              {{selectValue @item.templateOutput}}
              {{on "change" this.setTemplateOutput}}
            >
              {{#each OUTPUT_TEMPLATES as |template|}}
                <option value={{template.value}}>{{template.key}}
                  ([{{template.value}}])</option>
              {{/each}}
            </select>
          </div>

          <div class="form-label">Introduction</div>
          <p class="form-text">Content displayed to users when they are viewing
            their results. If left blank, the text from the input form will be
            displayed.</p>
          {{#if isReadOnly}}
            <textarea
              class="form-control font-monospace form-control-small lh-sm mb-3"
              id="{{uniqueId}}-markdownOutput"
              rows="15"
              readonly
            >{{@item.markdownOutput}}</textarea>
          {{else}}
            <div class="mb-3">
              <MarkdownEditor
                @markdown={{@item.markdownOutput}}
                @toolbar={{SidebarAll}}
                @mode={{ViewMode.EditorOnly}}
                @onUpdate={{this.setMarkdownOutput}}
              >
                <:preview as |markdown|>
                  <pre>{{markdown}}</pre>
                </:preview>
              </MarkdownEditor>
            </div>
          {{/if}}
        </fieldset>
      </:form>
    </EditRecord>
  </template>
}
